<template>
  <div class="main-content-container overflow-hidden">
    <PageTitle pageTitle="Reportes - Estadísticas del Torneo" />

    <Report />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PageTitle from "@/components/Common/PageTitle.vue";
import Report from "@/components/Pages/Admin/Reports/tournament-statistics.vue";

export default defineComponent({
  name: "ReportTournamentStatisticsPage",
  components: {
    PageTitle,
    Report,
  },
});
</script>















